"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _context = require("../../context");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _constants = require("../constants");

var _utils2 = require("../utils");

var _windowsHighContrastStyles = require("./windowsHighContrastStyles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var BoxContainer = (0, _context.styledWithTheme)(_layout.Col)(function (_ref) {
  var _ref$theme = _ref.theme,
      selectors = _ref$theme.selectors,
      isInHighContrast = _ref$theme.isInHighContrast,
      disabled = _ref.disabled,
      error = _ref.error,
      getInputStyles = _ref.getInputStyles,
      isInverted = _ref.isInverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getBorder = function getBorder(color) {
    return "".concat((0, _utils.px)(_constants.CHECKBOX_BORDER_WIDTH), " solid ").concat(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var backgroundColor = (0, _utils2.getBackgroundColor)(getColorParams);
  var borderColor = (0, _utils2.getBorderColor)(getColorParams);
  var checkedColor = (0, _utils2.getCheckedBorderColor)(getColorParams);
  var checkedTextColor = (0, _utils2.getCheckedTextColor)(getColorParams);
  var stateStyles = {};

  if (!disabled) {
    var getOutline = function getOutline(color) {
      return "".concat((0, _utils.px)(_constants.CHECKBOX_BORDER_WIDTH), " solid ").concat(color);
    };

    var focusColor = (0, _utils2.getFocusColor)(getColorParams);
    var hoverColor = (0, _utils2.getHoverColor)(getColorParams);
    var hoverBackgroundColor = (0, _utils2.getHoverDetailedBackgroundColor)(getColorParams);
    stateStyles = {
      'input:active ~ &': _objectSpread({
        outline: getOutline(hoverColor),
        backgroundColor: hoverBackgroundColor,
        borderColor: hoverColor
      }, getInputStyles({
        getColorParams: getColorParams,
        state: 'active'
      })),
      'input:active:checked ~ &': _objectSpread(_objectSpread({
        backgroundColor: hoverColor
      }, getInputStyles({
        checked: true,
        getColorParams: getColorParams,
        state: 'active'
      })), isInHighContrast && (0, _windowsHighContrastStyles.windowsHighContrastTickStyle)()),
      'input:focus ~ &': _objectSpread({
        outline: getOutline(focusColor),
        backgroundColor: backgroundColor,
        borderColor: focusColor
      }, getInputStyles({
        getColorParams: getColorParams,
        state: 'focus'
      })),
      'input:checked:focus ~ &': _objectSpread(_objectSpread({
        backgroundColor: focusColor,
        borderColor: focusColor
      }, getInputStyles({
        checked: true,
        getColorParams: getColorParams,
        state: 'focus'
      })), isInHighContrast && (0, _windowsHighContrastStyles.windowsHighContrastTickStyle)()),
      'input:hover ~ &': _objectSpread({
        backgroundColor: hoverBackgroundColor,
        borderColor: hoverColor,
        outlineColor: hoverColor
      }, getInputStyles({
        getColorParams: getColorParams,
        state: 'hover'
      })),
      'input:checked:hover ~ &': _objectSpread(_objectSpread({
        backgroundColor: hoverColor,
        borderColor: hoverColor
      }, getInputStyles({
        checked: true,
        getColorParams: getColorParams,
        state: 'hover'
      })), isInHighContrast && (0, _windowsHighContrastStyles.windowsHighContrastTickStyle)())
    };
  }

  return _objectSpread(_objectSpread({
    flex: 1,
    padding: (0, _utils.px)(selectors.space('S300')),
    height: '100%',
    boxSizing: 'border-box',
    justifyContent: 'flex-start',
    border: getBorder(borderColor),
    backgroundColor: backgroundColor,
    color: (0, _utils2.getDetailedBoxTextColor)(getColorParams),
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'border-color 0.1s, backgroundColor 0.1s, box-shadow 0.1s',
    outlineOffset: 2,
    'input:checked ~ &': _objectSpread(_objectSpread({
      border: getBorder(checkedColor),
      backgroundColor: checkedColor,
      color: checkedTextColor
    }, getInputStyles({
      checked: true,
      getColorParams: getColorParams
    })), isInHighContrast && (0, _windowsHighContrastStyles.windowsHighContrastTickStyle)())
  }, stateStyles), isInHighContrast && disabled && (0, _windowsHighContrastStyles.windowsHighContrastDisableStyle)());
});
var _default = BoxContainer;
exports.default = _default;